import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import './style.less';
const ewmbg = require('../../../common/image/v2/ewmbg.png');
export default class Jumppage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div className="jumppage">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()} />}
                >生活服务</NavBar>
                <div className="contentBox">
                <img
                    src={ewmbg}
                    alt=""
                    style={{ width: '100%', verticalAlign: 'top' }}
                    onLoad={() => {
                        window.dispatchEvent(new Event('resize'));
                    }}
                />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/Jumppage/index.js